import { iwocapayTelDisplay } from '../../../src/constants.json';

export const OUTSTANDING_APPLICATION_ERROR_CODE_MESSAGES = {
  OutstandingBrokerOffer: `We can’t process a new application for you right now because you already have an application with us via a third party. Get in touch on ${iwocapayTelDisplay} to let us know which application you’d like to proceed with.`,
  OutstandingCreditCardAccount: `We can’t process an iwocaPay application for you right now because you already have an application with us for our Credit Card. Get in touch on ${iwocapayTelDisplay} to let us know which application you’d like to proceed with.`,
} as const;

export type OutstandingApplicationErrorCode =
  keyof typeof OUTSTANDING_APPLICATION_ERROR_CODE_MESSAGES;

function isOutstandingApplicationErrorCode(
  errorCode: string,
): errorCode is OutstandingApplicationErrorCode {
  return errorCode in OUTSTANDING_APPLICATION_ERROR_CODE_MESSAGES;
}

export function getOutstandingApplicationErrorMessage(
  error: unknown,
): string | null {
  if (!error || typeof error !== 'object' || !('message' in error)) {
    return null;
  }
  const message = (error as { message?: unknown }).message;
  if (typeof message !== 'string') return null;

  try {
    const parsed = JSON.parse(message) as {
      errors?: { code?: string; detail?: string }[];
    };
    if (!parsed?.errors) return null;
    for (const { code } of parsed.errors) {
      if (code && isOutstandingApplicationErrorCode(code)) {
        return OUTSTANDING_APPLICATION_ERROR_CODE_MESSAGES[code];
      }
    }
  } catch {
    // Body was not JSON — not an outstanding-application error.
  }
  return null;
}
